import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';
import { ArrowLeft, Mail } from 'lucide-react';
import { useToast } from '../../hooks/use-toast';

const ForgotPassword = () => {
  const navigate = useNavigate();
  const { toast } = useToast();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [emailSent, setEmailSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const { authAPI } = await import('../../api');
      await authAPI.forgotPassword(email);
      
      setEmailSent(true);
      toast({
        title: "Email envoyé",
        description: "Vérifiez votre boîte mail pour réinitialiser votre mot de passe",
      });
    } catch (error) {
      toast({
        title: "Erreur",
        description: "Une erreur est survenue. Veuillez réessayer.",
        variant: "destructive"
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#111111] flex items-center justify-center px-6 py-32">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold mb-2">
            <span className="text-[#A6A6A6]">GT</span>
            <span className="text-[#C00000]"> ENGINEERING</span>
          </h1>
          <p className="text-[#A6A6A6]">Engineered Performance.</p>
        </div>

        <Card className="bg-[#1a1a1a] border-[#A6A6A6]/20">
          <CardHeader>
            <CardTitle className="text-white">Mot de passe oublié</CardTitle>
            <CardDescription className="text-[#A6A6A6]">
              Entrez votre email pour recevoir un lien de réinitialisation
            </CardDescription>
          </CardHeader>
          <CardContent>
            {!emailSent ? (
              <form onSubmit={handleSubmit} className="space-y-4">
                <div className="space-y-2">
                  <Label htmlFor="email" className="text-[#A6A6A6]">Adresse email</Label>
                  <div className="relative">
                    <Mail className="absolute left-3 top-3 h-5 w-5 text-[#A6A6A6]" />
                    <Input
                      id="email"
                      type="email"
                      placeholder="votre@email.com"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      className="bg-[#111111] border-[#A6A6A6]/30 text-white pl-10 focus:border-[#C00000]"
                      required
                    />
                  </div>
                </div>

                <Button 
                  type="submit" 
                  className="w-full bg-[#C00000] hover:bg-[#C00000]/90 text-white font-semibold"
                  disabled={loading}
                >
                  {loading ? 'Envoi en cours...' : 'Envoyer le lien de réinitialisation'}
                </Button>
              </form>
            ) : (
              <div className="text-center py-6">
                <div className="mb-4 inline-block p-4 bg-[#C00000]/10 rounded-full">
                  <Mail className="h-10 w-10 text-[#C00000]" />
                </div>
                <h3 className="text-white font-bold text-lg mb-2">Email envoyé !</h3>
                <p className="text-[#A6A6A6] mb-4">
                  Si un compte existe avec cet email, vous recevrez un lien de réinitialisation dans quelques instants.
                </p>
                <p className="text-[#A6A6A6] text-sm">
                  Pensez à vérifier vos spams si vous ne recevez rien.
                </p>
              </div>
            )}

            <div className="mt-6 text-center">
              <button
                onClick={() => navigate('/login')}
                className="text-[#C00000] hover:underline font-semibold inline-flex items-center gap-2"
              >
                <ArrowLeft className="h-4 w-4" />
                Retour à la connexion
              </button>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default ForgotPassword;
